import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainRoutingModule } from './main-routing.module';
import { MainComponent } from './main.component';
import { FullComponent } from '../layouts/full/full.component';
import { AppSidebarComponent } from '../layouts/full/sidebar/sidebar.component';
import { AppHeaderComponent } from '../layouts/full/header/header.component';
import { SharedModule } from '../shared/shared.module';
import { EditpComponent } from './editp/editp.component';
import { AdminAddUserComponent } from './admin-add-user/admin-add-user.component';
import { MainService } from './main.service';
import { AdminAddAdminComponent } from './admin-add-admin/admin-add-admin.component';
import { AdminAddCompanyComponent } from './admin-add-company/admin-add-company.component';
import { AdminAddSchoolComponent } from './admin-add-school/admin-add-school.component';
import { ChangePasswordComponent } from './change-password/change-password.component';


@NgModule({
  declarations: [MainComponent,FullComponent,AppSidebarComponent,AppHeaderComponent, EditpComponent, AdminAddUserComponent, AdminAddAdminComponent, AdminAddCompanyComponent, AdminAddSchoolComponent, ChangePasswordComponent],
  imports: [
    CommonModule,
    MainRoutingModule,
    SharedModule
  ],
  providers:[MainService]
})
export class MainModule { }
